import AreaRevenuesContainer from './AreaRevenuesContainer';
export default AreaRevenuesContainer;